// extracted by mini-css-extract-plugin
module.exports = {"cta":"GetTheAppButton__cta___I2btj"};